import { IconBasketQuestion, IconClipboardList, IconCoins, IconUsers } from '@tabler/icons-react'
import { NavigationLink, NavigationLinksContext } from '#features/navigation'
import { getCurrentUserRoleInfo } from '#shared/lib/auth'

interface SupportDataProviderProps {
  children: React.ReactNode
}

export default function SupportDataProvider({ children }: SupportDataProviderProps) {
  const navigationLinks: NavigationLink[] = [
    {
      to: '/support/payouts',
      displayName: 'Выплаты',
      icon: <IconCoins />,
    },
    {
      to: '/support/services',
      displayName: 'Услуги',
      icon: <IconBasketQuestion />,
    },
    {
      to: '/support/orders',
      displayName: 'Заказы',
      icon: <IconClipboardList />,
    },
  ]

  const roleInfo = getCurrentUserRoleInfo()

  if (roleInfo.role === 'manager') {
    navigationLinks.push({
      to: '/support/staff',
      displayName: 'Исполнители',
      icon: <IconUsers />,
    })
  }

  return <NavigationLinksContext.Provider value={navigationLinks}>{children}</NavigationLinksContext.Provider>
}
